import type { FinancialPeriod } from "@inrev/common";

// Income statement row ids, matching the ids produced by buildIncomeStatementViewModel, which uses
// each field key as the row id directly. Constraining the values to the view's keys makes a renamed
// or removed field a compile error here, instead of a silent `null` at runtime.
type IncomeStatementRowId = keyof FinancialPeriod.IncomeStatementView;

export const IS = {
	revenue: "revenue",
	grossProfit: "grossProfit",
	operatingExpenses: "operatingExpenses", // G&A
	operatingProfit: "operatingProfit",
	netProfit: "netProfit",
	depreciationAndAmortization: "depreciationAndAmortization",
	interestExpense: "interestExpense",
	taxes: "taxes",
} as const satisfies Record<string, IncomeStatementRowId>;
